import { render, staticRenderFns } from "./CFormRadio.vue?vue&type=template&id=7c0aff1c&scoped=true&"
import script from "./CFormRadio.vue?vue&type=script&lang=js&"
export * from "./CFormRadio.vue?vue&type=script&lang=js&"
import style0 from "./CFormRadio.vue?vue&type=style&index=0&id=7c0aff1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0aff1c",
  null
  
)

export default component.exports